module.exports = __webpack_public_path__ + "img/598-42dfb3.png";